export const CHECKOUT_URL = 'https://the-wedding-pro-os.impultienda.ar/checkout'
export const PRICE = '$19'
export const ANCHOR_PRICE = '$97'
export const SAVINGS = '$78'
export const TOTAL_VALUE = '$273'
export const SUPPORT_EMAIL = 'support@directtheday.com'
export const INSTAGRAM = '@directtheday'
